module.exports = __webpack_public_path__ + "img/darkBrown_attached.c9465809.svg";